import "./skills.css";
import Web from "../../assets/web-design.png";
import Devloper from "../../assets/developer.png";
import Logodesign from "../../assets/logo-desiner.png";
import Coding from "../../assets/coding.png";

import { TypeAnimation } from 'react-type-animation';


function Skills() {
  return (
    <section id="skills">
      <span className="skillTitle">What I do</span>

      <TypeAnimation
      sequence={[
        // Same substring at the start will only be typed out once, initially
        'I am a skilled and passionate web designer & developer with experience in creating visually appealing and user-friendly websites.I am also knowledge about react,js and python,C++,java etc. I have a strong  understanding of design software such as Canva, Animation image generator.',
        1000
        
      ]}

      className="skillDescrip"
      wrapper="span"
      speed={50}
      style={{ display: 'inline-block' }}
      repeat={Infinity}
    />

      <span >
        
      </span>

      <div className="skillbers">
        <div className="bers" data-aos="fade-up"
     data-aos-anchor-placement="center-bottom" data-aos-duration="1000" >
          <img src={Web} alt="web-design" className="bers-img" />
          <div className="skillberText">
            <h3>Web Design..</h3>
            <p>
              "Crafting digital experiences that seamlessly blend aesthetics and
              functionality for an engaging and user-centric web design."
            </p>
          </div>
        </div>

        <div className="bers" data-aos="fade-up"
     data-aos-anchor-placement="center-bottom" data-aos-duration="1000" >
          <img src={Devloper} alt="" className="bers-img" />
          <div className="skillberText">
            <h3>Website Develop..</h3>
            <p>
              "Creating smooth digital experiences through innovative web
              development solutions."
            </p>
          </div>
        </div>

        <div className="bers" data-aos="fade-up"
     data-aos-anchor-placement="center-bottom" data-aos-duration="1000" >
          <img src={Logodesign} alt="" className="bers-img" />
          <div className="skillberText">
            <h3>Logo Design</h3>
            <p>
              "Crafting identities, one pixel at a time - where creativity meets
              distinction."
            </p>
            
          </div>
        </div>

        <div className="bers" data-aos="fade-up"
     data-aos-anchor-placement="center-bottom" data-aos-duration="1000" >
          <img src={Coding} alt="" className="bers-img" />
          <div className="skillberText">
            <h3>Programming Languages</h3>
            <p>"Solving problem & making decision using knowledge C++,  Python, JS etc."</p>
          </div>
        </div>
      </div>
    </section>
  );
}
export default Skills;
